<template>
	
<div class="risk">

	<div class="risk-title">{{ section.treatment.more.detail.title }}</div>

	<div class="risk-table" v-for="table in tables" :key="table">

		<div class="risk-table-row is-head">

			<div class="risk-table-row-content">
					
				<div class="risk-table-label">{{ section.treatment.more.detail[table] }}</div>
				<div class="risk-table-item">{{ section.treatment.more.detail.chance }}</div>
				<div class="risk-table-item">{{ section.treatment.more.detail.advice }}</div>

			</div>

		</div>

		<div class="risk-table-row" v-for="(item, index) in section.treatment[treatment][table]" :key="index">

			<div class="risk-table-row-content">
				
				<div class="risk-table-label">{{ item.title }}<small v-if="item.subtitle">{{ item.subtitle }}</small></div>
				<div class="risk-table-item">
					
					{{  item.chance }}

					<div v-if="item.graph.enabled && !$isPatient" class="riskf-buttons">

						<div class="riskf-buttons-text" v-if="cates !== item.id">View graph</div>
						<div class="riskf-buttons-text" v-if="cates === item.id">Close graphs</div>
						<div class="riskf-buttons-button is-cates" v-on:click="onCatesClick(item.id)"></div>

					</div>

				</div>
				<div class="risk-table-item">{{ item.advice }}</div>

			</div>

			<com-cates :max="1000" class="risk-graph" :issue="item.graph.issue" action="break a bone" :bad="adjustedScore" :change="score - adjustedScore" v-if="cates === item.id && !$isPatient" title="With Osteoporosis Medicine" />

		</div>

	</div>

</div>

</template>

<script>

import comCates from '../../../common/Cates'

export default {

	props: ['section', 'treatment'],

	components: {
		'com-cates': comCates
	},

	data: function() {

		return {
			cates: 0,
			tables: ['effects', 'issues']
		}

	},

	computed: {

		rawScore: function() {

			return this.frax('major')

		},

		score: function() {

			return Math.round(this.rawScore) * 10

		},

		adjustedScore: function() {

			return Math.round(this.rawScore * (1 - (this.section.treatment[this.treatment].reduce['major'] / 100))) * 10

		}

	},

	methods: {

		onCatesClick: function(id) {

			this.cates = (id === this.cates) ? false : id

		}

	}

}

</script>

<style scoped>

.risk {
	background-color: #fff;
	padding: 32px;
	border-radius: 17px;
	margin-bottom: 16px;
}

.risk-title {
	color: #343434;
	font-size: 24px;
	margin-bottom: 32px;
	font-weight: 600;
}

.risk-table {
	margin-bottom: 32px;
}

.risk-table:last-child {
	margin-bottom: 0px;
}

.risk-table-row-content {
	display: flex;
}

.risk-table-label {
	width: 300px;
	margin-right: 16px;
	flex-shrink: 0;
	color: #343434;
	font-size: 16px;
	line-height: 20px;
	font-weight: 600;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 16px 0px;
}

.risk-table-row.is-head .risk-table-label {
	font-size: 24px;
	line-height: 24px;
}

.risk-table-label small {
	font-weight: 300;
}

.risk-table-item {
	flex-grow: 1;
	flex-shrink: 0;
	padding: 16px;
	flex-basis: 0;
	color: #343434;
	font-size: 16px;
	line-height: 20px;
	font-weight: 600;
	background-color: #F6F6F6;
	padding: 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	justify-content: center;
	margin: 2px;
}

.risk-table-row.is-head .risk-table-item {
	background-color: #343434;
	color: #fff;
	border-radius: 6px 6px 0px 0px;
}

.riskf-buttons {
	margin-top: 16px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.riskf-buttons-text {
	text-transform: uppercase;
	color: #343434;
	font-size: 10px;
	letter-spacing: 1px;
	font-weight: 600;
	margin-right: 10px;
}

.riskf-buttons-button {
	cursor: pointer;
	width: 44px;
	margin-left: 10px;
	height: 44px;
	border-radius: 22px;
	background-color: #656D78;
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.riskf-buttons-button.is-cates {
	background-image: url(~@/assets/aid/risk/risk/cates.svg);
}

.risk-graph {
	margin: 32px auto;
}

</style>